module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAzklEQVQ4jZ2TwQnCQBBFX8QG0oVHc/GWEoQU4cESFBsQj56swJMXexA7UPRg7CDpIN+DE1k2bkx88BkCM3/+BBZJY0m5+pNLSiJJJXAH1vRjAYwwt1QSPZVK0tDcYqsTIHG2XIBTIEEMUBsMrGbA0mnatRi8Z+yEzIkWOWo7IXNPcFFg41d8gymwaunfA9vmHeFvn0Y6P8HR1Jlv/yD6tdXFjzwDKk+HLgkqq2dg7vU8ArOVa1BYvZq6UAJEkgrgBmw6DtZ8HlMi6fnvc34BNnID0vKe9pwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_list.png
// module id = OvfD
// module chunks = 1